import { render, staticRenderFns } from "./OrderViewer.vue?vue&type=template&id=4920a2f6&"
import script from "./OrderViewer.vue?vue&type=script&lang=js&"
export * from "./OrderViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports